// components/EventCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import './EventCard.css';

const EventCard = ({ event }) => {
    console.log('EventCard props:', event); // Debug log

    if (!event) {
        console.log('No event data provided to EventCard');
        return null;
    }

    return (
        <Link to={`/event/${event.id}`} className="event-card">
            <div className="event-image">
                <img 
                    src={event.image_url}
                    alt={event.title}
                    onError={(e) => {
                        console.log('Image failed to load:', event.image_url);
                        e.target.src = '/placeholder-event.jpg';
                    }}
                />
            </div>
            <div className="event-info">
                <h3>{event.title}</h3>
                <p className="event-date">{event.date}</p>
                <p className="event-location">{event.location?.venue}</p>
                <p className="event-price">{event.price}</p>
            </div>
        </Link>
    );
};

export default EventCard;
